import React from 'react';
import LayoutProvider from '../../../../../../Contexts/LayoutProvider';
import TableMobile from './TableMobile';
import TableWeb from './TableWeb';

function TabAgencyPaymentsPage({ data }) {
    return (
        <LayoutProvider>
            <TableWeb layout="default" data={data} />
            <TableMobile layout={['md', 'sm', 'xs', 'xxs']} data={data} />
        </LayoutProvider>
    );
}

export default TabAgencyPaymentsPage;
